/** @deprecated Re-exports from agent-dependencies.ts for backward compatibility. */
export { getAgentCapabilities } from "./agent-dependencies.js";
export type { AgentCapability } from "./agent-dependencies.js";
